module.exports = __webpack_public_path__ + "img/fourthly.b93228ff.png";